module.exports = "/_next/static/images/186b77778fc7212b7fa623374f7029ae-nucommunity-xs@1x.jpg";